module.exports = __webpack_public_path__ + "static/onehealth-3df5ea31ee526f385cf245346c8d3973.png";